import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const DomainSearchGateBiExtension = ModuleExtensions.biEventsExtension();
//# sourceMappingURL=DomainSearchGateBiExtension.js.map